import React from 'react';
import { CtaButton } from './CtaButton';
import { OFFER_ANCHOR } from '../../data/content';
interface CtaBlockProps {
  label?: string;
  note?: string;
  href?: string;
  onDark?: boolean;
}
export function CtaBlock({
  label = '🚀 Sí, quiero comenzar ahora',
  note = 'Acceso Inmediato • Garantía de 7 Días',
  href = OFFER_ANCHOR,
  onDark = false
}: CtaBlockProps) {
  return <div className="mx-auto mt-3 max-w-md text-center" data-id="element-157" data-mp="j54hvbdvolui">
      <CtaButton href={href} data-id="element-158" data-mp="j4kxzp4o3ndu">{label}</CtaButton>
      {note && <p className={`mt-1 text-xs font-medium ${onDark ? 'text-white/80' : 'text-navy/70'}`} data-id="element-159" data-mp="e5rumpj3hcre">{note}</p>}
    </div>;
}